// extracted by mini-css-extract-plugin
export default {"welcomePageContainer":"WelcomePage_welcomePageContainer__SrSHR","box":"WelcomePage_box__Ml8o1","yellow":"WelcomePage_yellow__cG1AM"};